import { Injectable, Injector } from "@angular/core";
import { AppContext, DataPropInfo, DataTypeInfo, Entity, FrameContext, NgFormControl, Repository } from "@farris/devkit";

@Injectable()
export class FormService {
  constructor(
    private injector: Injector,
    private appContext: AppContext,
    private repository: Repository<Entity>
  ) {
  }
  /**
   * æ ¹æ®å­æ®µè·¯å¾è·åè¯¥å­æ®µå¨å¡çæè¡¨æ ¼ä¸­çç´¢å¼
   * @param source ngFormControlsæany[][]
   * @param propertyPath å­æ®µé¤bindingPathä¹å¤çå®æ´è·¯å¾
   * @returns 
   */
  public getIndex(source: { [propertyName: string]: NgFormControl } | any[], propertyPath: string) {
    if (Array.isArray(source)) {
      const combine: any[] = source.reduce((result: any[], group: any[]) => {
        return result.concat(group);
      }, []);
      return combine.findIndex((item: any) => item.field === propertyPath);
    } else if (Object.prototype.toString.call(source) === '[object Object]') {
      return Object.keys(source).findIndex(key => source[key].binding === propertyPath);
    }
  }
  
}